module.exports = __webpack_public_path__ + "img/9788988556795.6c8eb17e.jpg";